import script from "./nextSteps.vue?vue&type=script&setup=true&lang=js"
export * from "./nextSteps.vue?vue&type=script&setup=true&lang=js"

import "./nextSteps.vue?vue&type=style&index=0&id=2292a960&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2292a960"]])

export default __exports__